<!--<template>-->
<!--<div class="imgCarousel" v-if="imgCarouselShow">-->
<!--&lt;!&ndash;<img @click="imgCarouselShow=false" class="imgCarousel_close" src="../../assets/images/close.png" alt="">&ndash;&gt;-->
<!--&lt;!&ndash;<el-carousel arrow="always" :autoplay="false" :initial-index="initialIndex">&ndash;&gt;-->
<!--&lt;!&ndash;<el-carousel-item v-for="item in imgCarouselList" :key="item.fileId">&ndash;&gt;-->
<!--&lt;!&ndash;<img :src="item.src" alt="">&ndash;&gt;-->
<!--&lt;!&ndash;</el-carousel-item>&ndash;&gt;-->
<!--&lt;!&ndash;</el-carousel>&ndash;&gt;-->
<!--<el-image-->
<!--style="width: 200px; height: 200px"-->
<!--v-for="(item,index) in imgCarouselList"-->
<!--:src="require(item.src)"-->
<!--:zoom-rate="1.2"-->
<!--:preview-src-list="imgCarouselList"-->
<!--:initial-index="index"-->
<!--fit="cover"-->
<!--&gt;-->
<!--<template >-->
<!--<div class="image-slot">-->
<!--<img @click="imgCarouselShow=false" class="imgCarousel_close" src="../../assets/images/close.png" alt="">-->
<!--</div>-->
<!--</template>-->
<!--</el-image>-->
<!--</div>-->
<!--</template>-->

<!--<script>-->
<!--import {reactive, onMounted, ref, watch} from 'vue';-->

<!--export default {-->
<!--name: "ImgCarousel",-->
<!--props: ["imgListIndex", "imgList"],-->
<!--setup(props, context) {-->
<!--let imgCarouselList = ref()-->
<!--let imgCarouselShow = ref(false);-->
<!--let initialIndex = ref(0)-->
<!--watch(() => props.imgList, (newVal) => {-->
<!--imgCarouselList.value = newVal;-->
<!--}, {-->
<!--immediate: true-->
<!--})-->
<!--watch(() => props.imgListIndex, (newVal) => {-->
<!--initialIndex.value = newVal-->
<!--}, {-->
<!--immediate: true-->
<!--})-->
<!--const showImgCarousel = () => {-->
<!--imgCarouselShow.value = true-->
<!--console.log(imgCarouselList.value)-->
<!--}-->
<!--onMounted(() => {-->

<!--})-->
<!--return {-->
<!--imgCarouselShow,-->
<!--imgCarouselList,-->
<!--initialIndex,-->
<!--showImgCarousel-->
<!--}-->
<!--}-->
<!--}-->
<!--</script>-->

<!--<style scoped>-->

<!--</style>-->
<!--定义要实现拖拽功能的元素。高度和宽度择其一进行设置，否则图片会变形；zoom属性用来实现图片的放大缩小；transform.translate属性用来实现图片的移动-->
<template>
    <div class="imgCarousel" v-if="imgCarouselShow">
        <img @click="closeImg" class="imgCarousel_close" src="../../assets/images/close.png" alt="">
        <el-carousel @change="prevNextImg" arrow="always" :autoplay="false" :initial-index="initialIndex">
            <el-carousel-item v-for="item in imgCarouselList" :key="item.fileId">
                <img :src="item.src"  :style="{'zoom':imgPosition.zoom,'transform':'translate('+imgPosition.x+'px,'+imgPosition.y+'px)'}" draggable="true"
                     @wheel="change_img($event)" @dragstart.stop="dragstart($event)" @dragover.stop="dragover($event)" @dragend.stop="dragend($event)" id="pic">
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
    import {reactive, onMounted, ref, watch} from 'vue';

    export default {
        name: "ImgCarousel",
        props: ["imgListIndex", "imgList"],
        setup(props, context) {
            let imgCarouselList = ref()
            let imgCarouselShow = ref(false);
            let initialIndex = ref(0)
            watch(() => props.imgList, (newVal) => {
                imgCarouselList.value = newVal;
            }, {
                immediate: true
            })
            watch(() => props.imgListIndex, (newVal) => {
                initialIndex.value = newVal
            }, {
                immediate: true
            })
            let imgPosition = ref({
                zoom:1,
                x:0,
                y:0,
                imgx:'',
                imgy:'',
                startx:'',
                starty:'',
                endx:0,
                endy:0
            })
            const showImgCarousel = () => {
                imgCarouselShow.value = true
                console.log(imgCarouselList.value)
            }
            const change_img = (e)=>{
                if (e.wheelDelta > 0 || e.detail < 0) {
                    //当鼠标滚轮向上滚动时
                    imgPosition.value.zoom = imgPosition.value.zoom+0.2
                }
                if (e.wheelDelta < 0 || e.detail > 0) {     //当鼠标滚轮向下滚动时
                    if(imgPosition.value.zoom>0.6){
                        imgPosition.value.zoom= imgPosition.value.zoom-0.2
                    }
                }
            }
            const dragstart = (e)=>{
                imgPosition.value.startx=e.pageX;
                imgPosition.value.starty=e.pageY
            }
            const dragover = (e)=>{
                imgPosition.value.x=e.pageX-imgPosition.value.startx + imgPosition.value.endx
                imgPosition.value.y=e.pageY-imgPosition.value.starty+imgPosition.value.endy
            }
            const dragend = (e)=>{
                imgPosition.value.endx=imgPosition.value.x;
                imgPosition.value.endy=imgPosition.value.y
            }
            const closeImg =()=>{
                imgCarouselShow.value = false
                imgPosition.value ={
                    zoom:1,
                    x:0,
                    y:0,
                    startx:0,
                    starty:0,
                    endx:0,
                    endy:0
                }
            }
            const prevNextImg = ()=>{
                imgPosition.value ={
                    zoom:1,
                    x:0,
                    y:0,
                    startx:0,
                    starty:0,
                    endx:0,
                    endy:0
                }
            }

            onMounted(() => {

            })
            return {
                imgCarouselShow,
                imgCarouselList,
                initialIndex,
                showImgCarousel,
                change_img,
                imgPosition,
                dragstart,
                dragover,
                closeImg,
                dragend,
                prevNextImg
            }
        }
    }
</script>

<style scoped>

</style>

